<template>
<div class="userCenter">
  <div class="banner-top">
    <div class="user-box">
      <span class="username">Hi,&nbsp;&nbsp;{{username}}</span>
    </div>
  </div>
  <div class="user-brown">
    <div class="zx-list">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="浏览历史" name="first">
        <div class="list-box" v-for="(item,i) in itemList" :key="i" v-if="item">
          <div class="img-box">
            <img class="thumb-img" :src="item.img || ''" alt="">
          </div>
          <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name">
            <div class="article_title">
              <div class="title">{{ item.title }}</div>
              <div class="list-content">{{ item.desc }}</div>
              <div class="list-bottom">
                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
              </div>
            </div>
          </a>
        </div>
        <div class="more">
          <div class="cursorPointer">
            <div @click="getListMore">点击加载更多...</div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="我的权限" name="second">
        <div class="role-box" v-if="myList && myList.length > 0">
          <div class="product" v-for="(item, i) in myList" :key="i">
              <div class="product-name">{{item.product_name || '全站通会员'}}</div>
              <!-- <div class="product-name">{{'全站通会员'}}</div> -->
              <div class="product-time" v-if="item.start_time && item.end_time">有效期:&nbsp;&nbsp;{{item.start_time.substring(0,10)}} -- {{item.end_time.substring(0,10)}}</div>
              <div class="product-phone" v-if="item.phone">限 {{item.phone}} 号码会员使用</div>
          </div>
        </div>
        <div class="empty-tip" v-else>
          <i class="el-icon-lock"></i>
          <p>您还未开通任何会员权限</p>
          <router-link to="/Member" class="open-vip-btn">立即开通会员</router-link>
        </div>
      </el-tab-pane>
      <el-tab-pane label="我的订单" name="order">
        <div class="order-box">
          <el-table
            :data="orderList"
            border
            style="width: 100%"
            empty-text="暂无订单记录">
            <el-table-column
              prop="order_id"
              label="订单编号"
              min-width="180">
            </el-table-column>
            <el-table-column
              prop="package_name"
              label="套餐名称"
              min-width="120">
            </el-table-column>
            <el-table-column
              prop="amount"
              label="金额"
              min-width="100">
              <template slot-scope="scope">
                ￥{{scope.row.amount}}
              </template>
            </el-table-column>
            <el-table-column
              prop="pay_method"
              label="支付方式"
              min-width="100">
              <template slot-scope="scope">
                {{scope.row.pay_method === 'transfer' ? '银行转账' : '在线支付'}}
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="订单状态"
              min-width="100">
              <template slot-scope="scope">
                <el-tag :type="orderStatusType(scope.row.status)">{{orderStatusText(scope.row.status)}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="下单时间"
              min-width="160">
            </el-table-column>
            <el-table-column
              label="合同"
              min-width="140"
              v-if="orderList && orderList.some(o => o.status === 2)">
              <template slot-scope="scope">
                <template v-if="scope.row.status === 2">
                  <el-button type="text" size="small" @click="downloadContractPDF(scope.row)">下载PDF</el-button>
                  <el-button type="text" size="small" @click="viewContract(scope.row)">查看HTML</el-button>
                </template>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="'我的消息' + (unreadCount > 0 ? '(' + unreadCount + ')' : '')" name="message">
        <div class="message-box">
          <div class="message-toolbar" v-if="messageList.length > 0">
            <el-button size="small" @click="readAllMessages">全部已读</el-button>
          </div>
          <div class="message-list" v-if="messageList.length > 0">
            <div class="message-item" v-for="(msg, i) in messageList" :key="i" :class="{'unread': !msg.is_read}" @click="readMessage(msg)">
              <div class="msg-header">
                <span class="msg-title"><i class="el-icon-bell" v-if="!msg.is_read"></i>{{msg.title}}</span>
                <span class="msg-time">{{msg.created_time}}</span>
              </div>
              <div class="msg-content">{{msg.content}}</div>
            </div>
          </div>
          <div class="empty-tip" v-else>
            <i class="el-icon-message"></i>
            <p>暂无消息</p>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="修改密码" name="third">
        <el-form :model="updateForm" class="reg">
          <el-form-item label="手机号">
            <el-input v-model="updateForm.phone" placeholder="请输入手机号" autocomplete="off"></el-input>
          </el-form-item>
          <div style="margin-bottom: 15px;">验证码</div>
          <div class="yzm">
            <div>
              <el-input v-model="updateForm.code" placeholder="请输入短信验证码" autocomplete="off"></el-input>
            </div>
            <div>
              <button type="button" class="txt btn cursorPointer" @click="getYzm">{{codeText}}</button>
            </div>
          </div>
          <el-form-item label="新密码">
            <el-input v-model="updateForm.password" placeholder="请输入6-16位字符的密码" type="password" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div class="register">
          <el-button type="primary" :disabled="btnRegState===false" :class="{btnBg:btnRegState}" @click="updatePwd">立即提交</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="基本资料" name="fourth">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="昵称">
            <el-input v-model="form.nickname"></el-input>
          </el-form-item>

          <el-form-item label="性别">
            <el-radio-group v-model="form.sex">
              <el-radio label="0">保密</el-radio>
              <el-radio label="1">男</el-radio>
              <el-radio label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmitInfo">立即提交</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="设备管理" name="five">
        <el-table
          :data="ipList"
          border
          style="width: 100%">
          <el-table-column
            prop="ip"
            label="IP地址"
            >
          </el-table-column>
          <el-table-column
            prop="name"
            label="设备名称"
            >
          </el-table-column>
          <el-table-column
            prop="state"
            label="设备状态"
            >
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="120">
            <template slot-scope="scope">
              <el-button @click="editDevices(scope.row, scope.$index)" type="text" size="small">修改</el-button>
              <el-button @click="delIp(scope.row)" type="text" size="small">申请删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
  </div>
</div>
</template>

<script>
import { hisList, basics, upPwd, Code,myProduct, ipList, ipDel } from "@/api/user";
import { orderList, messageList, messageRead, getContract } from "@/api/order";
import html2pdf from 'html2pdf.js';
export default {
  name: "UCenter",
  data() {
    return{
      activeName: this.$route.query.tab || 'first',
      codeText: '获取验证码',
      itemList: [],
      myList: [],
      ipList: [],
      orderList: [],
      messageList: [],
      unreadCount: 0,
      username:window.localStorage.getItem('username'),
      page: 1,
      radio: '0',
      form: {
        nickname: '',
        sex: '',
      },
      updateForm: {
        phone: '',
        password: '',
        code: '',
      },
    }
  },
  created() {
    this.getHistoryList()
    this.getMyProductList()
    this.getIpList()
    this.getOrderList()
    this.getMessageList()
    // this.onSubmitInfo()
  },
  computed :{
    btnRegState(){//当用户名和密码框都不为空时btnRegState==true,利用这个计算属性来动态控制按钮的禁用和颜色
      return this.updateForm.password !=="" && this.updateForm.phone !=="" && this.updateForm.code !==""
    }
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    getIpList() {
      ipList({username: this.username,src:1}).then((response) => {
        console.log(response);
        if (response.code === 1) {
          this.ipList = response.devices
        }
      });
    },
    editDevices(val, indexs) {
      this.$prompt('修改设备名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(({ value }) => {
          this.$message({
            type: 'success',
            message: '修改成功！'
          });
          val.name = value;

          // this.ipList[indexs].name = JSON.parse(value);
          // val.name = JSON.parse(value);
          this.ipList[indexs].name = value;
          // val.name = value;

          this.$set(this.ipList, indexs, val);
          console.log(val.ip);
          console.log(val.name);
          this.getData(val.ip,val.name)
        })
        .catch(() => {
          console.log('取消输入');
        });
    },
    getData(ip,name) {
      let params = new FormData();
      params.append('ip', ip);
      params.append('name', name);
      params.append('username', this.username);
      params.append('src', 1);
      // ipDel({ip:ip,name:name,username: this.username,src:1}).then((response) => {
      ipDel(params).then((response) => {
        console.log(response);
        if (response.code === 1) {
          this.$message.success({message:'申请修改成功',duration:1000,offset:400})
        }
      });
    },
    delIp(row) {
      console.log(row);
      let params = new FormData();
      params.append('ip', row.ip);
      params.append('username', this.username);
      params.append('src', 1);
      // ipDel({ip:row.ip}).then((response) => {
      ipDel(params).then((response) => {
        console.log(response);
        if (response.code === 1) {
          this.$message.success({message:'申请删除成功',duration:1000,offset:400})
        }
      });
    },
    getHistoryList() {
      hisList({username: this.username, page: this.page}).then((response) => {
        if (response && (response.code === 200 || response.code === 2000) && Array.isArray(response.data)) {
          this.itemList = this.itemList.concat(response.data)
        }
      });
    },
    getListMore() {
      this.page++;
      this.getHistoryList()
    },
    getMyProductList() {
      myProduct({username: this.username}).then((response) => {
        if (response.code === 200 && response.product) {
          this.myList = response.product
        } else {
          this.myList = []
        }
      }).catch(() => {
        this.myList = []
      });
    },
    getOrderList() {
      orderList({username: this.username}).then((response) => {
        if (response.code === 2000 || response.code === 200) {
          this.orderList = response.data || response.order || []
        }
      }).catch(() => {
        this.orderList = []
      });
    },
    orderStatusText(status) {
      const map = {
        0: '待支付',
        1: '已支付',
        2: '已开通',
        3: '已关闭',
        4: '已退款',
      };
      return map[status] || '待支付';
    },
    orderStatusType(status) {
      const map = {
        0: 'warning',
        1: 'primary',
        2: 'success',
        3: 'info',
        4: 'danger',
      };
      return map[status] || 'warning';
    },
    getMessageList() {
      messageList({}).then((response) => {
        if (response && (response.code === 2000 || response.code === 200) && response.data) {
          this.messageList = response.data.list || [];
          this.unreadCount = response.data.unread_count || 0;
        }
      }).catch(() => {});
    },
    readMessage(msg) {
      if (msg.is_read) return;
      messageRead({id: msg.id, action: 'read'}).then((response) => {
        if (response && (response.code === 2000 || response.code === 200)) {
          msg.is_read = true;
          if (this.unreadCount > 0) this.unreadCount--;
        }
      }).catch(() => {});
    },
    readAllMessages() {
      messageRead({action: 'read_all'}).then((response) => {
        if (response && (response.code === 2000 || response.code === 200)) {
          this.messageList.forEach(m => { m.is_read = true; });
          this.unreadCount = 0;
          this.$message.success({message: '已全部标记为已读', duration: 1500, offset: 400});
        }
      }).catch(() => {});
    },
    viewContract(row) {
      // 获取合同HTML内容，在新窗口打开
      getContract({order_id: row.order_id}).then((response) => {
        if (response && (response.code === 2000 || response.code === 200) && response.data && response.data.content) {
          const newWin = window.open('', '_blank');
          if (newWin) {
            newWin.document.write(response.data.content);
            newWin.document.close();
          } else {
            this.$message.warning({message: '请允许弹窗以查看合同', duration: 2000, offset: 400});
          }
        } else {
          this.$message.warning({message: (response && response.data) || '合同生成中，请稍后查看', duration: 2000, offset: 400});
        }
      }).catch(() => {
        this.$message.error({message: '获取合同失败', duration: 2000, offset: 400});
      });
    },
    downloadContractPDF(row) {
      // 获取合同HTML内容，使用html2pdf.js生成正式PDF文件下载
      this.$message.info({message: '正在生成PDF，请稍候...', duration: 2000, offset: 400});
      getContract({order_id: row.order_id}).then((response) => {
        if (response && (response.code === 2000 || response.code === 200) && response.data && response.data.content) {
          let htmlContent = response.data.content;
          // 将公章图片路径替换为base64内嵌
          const stampImg = new Image();
          stampImg.crossOrigin = 'anonymous';
          stampImg.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = stampImg.naturalWidth;
            canvas.height = stampImg.naturalHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(stampImg, 0, 0);
            const base64 = canvas.toDataURL('image/jpeg');
            htmlContent = htmlContent.replace(/\/static\/images\/bolanStamp\.jpg/g, base64);
            this._doGeneratePDF(htmlContent, row.order_id);
          };
          stampImg.onerror = () => {
            // 公章加载失败也继续生成（不带公章）
            this._doGeneratePDF(htmlContent, row.order_id);
          };
          stampImg.src = '/static/images/bolanStamp.jpg';
        } else {
          this.$message.warning({message: (response && response.data) || '合同生成中，请稍后查看', duration: 2000, offset: 400});
        }
      }).catch(() => {
        this.$message.error({message: '获取合同失败', duration: 2000, offset: 400});
      });
    },
    _doGeneratePDF(htmlContent, orderId) {
      // 创建临时容器
      const container = document.createElement('div');
      container.innerHTML = htmlContent;
      // 移除水印（PDF不需要）
      const watermarks = container.querySelectorAll('.watermark');
      watermarks.forEach(el => el.parentNode.removeChild(el));
      // 移除提示栏（PDF不需要）
      const tips = container.querySelectorAll('.no-print');
      tips.forEach(el => el.parentNode.removeChild(el));
      document.body.appendChild(container);

      const opt = {
        margin: [15, 15, 15, 15],
        filename: '电子合同_' + orderId + '.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true, letterRendering: true },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
      };
      html2pdf().set(opt).from(container).save().then(() => {
        document.body.removeChild(container);
        this.$message.success({message: 'PDF下载成功', duration: 1500, offset: 400});
      }).catch(() => {
        if (container.parentNode) document.body.removeChild(container);
        this.$message.error({message: 'PDF生成失败', duration: 2000, offset: 400});
      });
    },
    onSubmitInfo() {
      let data = {
        username: this.form.nickname,
        gender: this.form.sex,
      };
      basics( data ).then((response) => {
        if (response.code === 200) {
          console.log(response);
        }
      });
      console.log('submit!');
    },
    updatePwd(){
      let data = {
        phone: this.updateForm.phone,
        code: this.updateForm.code,
        password: this.updateForm.password,
      }
      upPwd( data ).then((response) => {
        console.log(response);
        // if (response.code === 2000 || response.code === 505 || response.code === 403) {

        // }
      });
    },
    getYzm(){
      Code(  {phone: this.updateForm.phone}  ).then(( response ) => {
        this.timer();
        // console.log( response );
      });
    },
    timer() {//验证码倒计时
      let num = 60;
      let that = this;
      that.codeText = num + "秒后重新发送";
      let time = setInterval(function() {
        if(num == 0) {
          clearInterval(time);
          time = null;
          that.codeText = "重发验证码";
        } else {
          num--;
          that.codeText = num + "秒后重新发送";
        }

      }, 1000);
    },
  }
}
</script>

<style scoped>
.banner-top {
  width: 100%;
  height: 100px;
  margin-top: 50px;
  line-height: 70px;
  background: url("../assets/images/banner_top.png") no-repeat center / cover;
}

.user-box{
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

.user-box img{
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.user-box .username{
  color: #FFFFFF;
  position: absolute;
  left: 0;
}

.user-brown{
  width: 1200px;
  min-height: 500px;
  margin: -40px auto 0;
}

>>>.el-tabs__nav-wrap:after {
   background-color: transparent;
}

.list-box {
  display: flex;
  background-color: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  height: 120px;
  padding: 10px 20px;
}


.img-box {
  margin-right: 40px;
}

.thumb-img {
  width: 240px;
  height: 120px;
  flex: 0 0 240px;
}

.list-title {
  position: relative;
}

.title {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #313131;
}

.list-content {
  font-size: 14px;
  line-height: 28px;
  color: #898989;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.list-bottom {
  font-size: 14px;
  bottom: 0;
  min-width: 860px;
  color: #898989;
  position: absolute;
  pointer-events: none;
}

.register{
  margin: 20px 0;
}

>>>.register .el-button--primary {
  background-color: #87b5f9;
  border-color: #87b5f9;
}

>>>.el-tabs__nav-wrap::after{
  background-color: transparent;
}

.yzm{
  display: flex;
  gap: 10px;
}

.btn {
  border: 1px solid #c9c9c9;
  background-color: #fff;
  color: #555;
  letter-spacing: 2px;
  height: 40px;
  padding: 0 15px;
  border-radius: 3px;
}

.cursorPointer {
  cursor: pointer;
}

>>>.reg .el-form-item {
  margin-bottom: 10px;
}

>>>.btnBg {
  background-color: rgb(0, 22, 70)!important;
  border-color: rgb(0, 22, 70)!important;
}

.more {
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin: 10px 0;
  font-size: 12px;
  color: #a0a8b0;
  text-align: center;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.product{
  width: 292px;
  height: 200px;
  background: url("../assets/images/VVIP.jpg") no-repeat;
  background-size: 292px 200px;
  margin-bottom: 10px;
  position: relative;
}

.role-box{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.order-box{
  padding: 10px 0;
}

.product .product-name{
  position: absolute;
  top: 55%;
  left: 0;
  right: 0;
  text-align: center;
  color: #ffe400;
  margin: 0 10px;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 1px;
}

.product .product-time{
  position: absolute;
  top: 72%;
  left: 0;
  right: 0;
  text-align: center;
  color: white;
  margin: 0 10px;
  font-size: 14px;
}

.product .product-phone{
  position: absolute;
  top: 86%;
  left: 0;
  right: 0;
  text-align: center;
  color: white;
  margin: 0 10px;
  font-size: 13px;
  opacity: 0.9;
}

.empty-tip{
  text-align: center;
  padding: 60px 0;
  color: #898989;
}

.empty-tip i{
  font-size: 60px;
  color: #c0c4cc;
}

.empty-tip p{
  font-size: 15px;
  margin: 16px 0 24px;
}

.empty-tip .open-vip-btn{
  display: inline-block;
  padding: 10px 32px;
  background-color: #001646;
  color: #fff;
  border-radius: 4px;
  font-size: 15px;
  text-decoration: none;
}

.empty-tip .open-vip-btn:hover{
  background-color: #0a2a6e;
}

.message-box {
  padding: 10px 0;
}
.message-toolbar {
  margin-bottom: 16px;
  text-align: right;
}
.message-list {
  max-width: 900px;
}
.message-item {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 14px 18px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: box-shadow 0.2s;
}
.message-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.message-item.unread {
  border-left: 3px solid #001646;
  background: #f0f5ff;
}
.msg-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}
.msg-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}
.msg-title i {
  color: #d4380d;
  margin-right: 4px;
}
.msg-time {
  font-size: 12px;
  color: #898989;
}
.msg-content {
  font-size: 13px;
  color: #595959;
  line-height: 22px;
}

>>>.el-tabs__item .is-active {
  color: #409eff!important;
}

>>>.el-tabs__item{
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/UCenter.vue